import React from 'react';
import { Image, ImageFit } from '@fluentui/react/lib/Image';
import { socialsList } from './socialsList';
import styles from './Socials.module.css';
import Strings from '../../translations/strings';

const Socials = () => {
    return (
        <section className={styles.socialsWrap}>
            <h2>{Strings.components.socials.title}</h2>
            <div className={styles.socialsList}>
                {socialsList.map((item) => (
                    <a
                        href={item.getLink()}
                        target="_blank"
                        rel="noreferrer noopener"
                        className={styles.imgLink}
                        key={item.alt}
                    >
                        <Image src={item.img} alt={item.alt}  imageFit={ImageFit.centerContain} className={styles.img} />
                    </a>
                ))}
            </div>
        </section>
    );
};

export default Socials;
